/*
 * Преобразовывает значение/объект в строку для запросов к апи настроек
 * @param body - значения настроек
 *
 * @example
 * ```ts
 * prepareBody({
 *     "schedule": [
 *         {
 *             "shipping_time": "18:00",
 *             "days": [
 *                 "monday",
 *                 "tuesday"
 *             ]
 *         }
 *     ],
 *     "end_assembling_time": "16:00"
 * })
 *
 * //   "{\"schedule\":[{\"shipping_time\":\"18:00\",\"days\":[\"monday\",\"tuesday\"]}],\"end_assembling_time\":\"16:00\"}"
 * ```
 */

export const prepareBody = (body: unknown): string | undefined => {
    try {
        if (typeof body === 'string' || typeof body === 'boolean' || typeof body === 'number') {
            return JSON.stringify(body);
        }

        if (body === null) {
            return undefined;
        }

        if (typeof body === 'object') {
            return JSON.stringify(body).replace(/"/g, '\"');
        }

        return undefined;
    } catch {
        return undefined;
    }
};
